var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCurtainsInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 342
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.879 0a3.855 3.855 0 00-2.64 1.038 3.814 3.814 0 00-1.2 2.556 305.192 305.192 0 01-5.651 41.509C85.097 119.238 45.438 175.186 2.575 190.39a3.832 3.832 0 00-2.29 2.163 3.8 3.8 0 00.112 3.139c11.135 22.086 17.632 48.647 17.632 77.246A176.114 176.114 0 016.355 336.8a3.807 3.807 0 00.413 3.534 3.852 3.852 0 003.162 1.665h304.14a3.85 3.85 0 003.161-1.665 3.8 3.8 0 00.413-3.534 176.105 176.105 0 01-11.672-63.863c0-28.6 6.5-55.16 17.631-77.246a3.813 3.813 0 00.112-3.139 3.831 3.831 0 00-2.291-2.163c-42.863-15.166-82.521-71.114-97.808-145.287a305.1 305.1 0 01-5.65-41.509 3.808 3.808 0 00-1.206-2.556A3.853 3.853 0 00214.12 0z",
    fill: "#003c3b"
  })));
}

export default __webpack_public_path__ + "e93d273e6bc9f245fe167d4583a2f097.svg";
export { SvgCurtainsInner as ReactComponent };